import script from "./FileHistoryDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileHistoryDetails.vue?vue&type=script&setup=true&lang=ts"

import "./FileHistoryDetails.vue?vue&type=style&index=0&id=16fb3530&scoped=true&lang=css"

import exportComponent from "/builds/SalesIT/ijaa/import-tool/ls-import-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16fb3530"]])

export default __exports__